import { ScheduleFormData } from "./request.type";

export const convertToApiFormat = (date: Date, time: { hour: string; minute: string; period: "AM" | "PM" }): string => {
	let hours = parseInt(time.hour);
	if (time.period === "PM" && hours !== 12) {
		hours += 12;
	} else if (time.period === "AM" && hours === 12) {
		hours = 0;
	}

	const scheduledDate = new Date(date);
	scheduledDate.setHours(hours, parseInt(time.minute), 0, 0);

	return scheduledDate.toISOString();
};

const parseTimeFromApiDate = (dateString: string) => {
	const date = new Date(dateString);
	let hours = date.getHours();
	const minutes = date.getMinutes();
	const period = hours >= 12 ? "PM" : "AM";
	
	// Convert to 12-hour format
	if (hours === 0) {
		hours = 12;
	} else if (hours > 12) {
		hours = hours - 12;
	}
	
	return {
		hour: hours.toString().padStart(2, '0'),
		minute: minutes.toString().padStart(2, '0'),
		period: period as "AM" | "PM"
	};
};

// Helper function to get default values
export const getDefaultValues = (scheduledDate?: string): ScheduleFormData => {
	if (scheduledDate) {
		const apiDate = new Date(scheduledDate);
		const timeObj = parseTimeFromApiDate(scheduledDate);
		
		return {
			date: apiDate,
			time: timeObj,
			confirmation: false
		};
	}
	
	// Default values when no scheduled date is provided
	return {
		date: new Date(),
		time: {
			hour: "09",
			minute: "00",
			period: "AM"
		},
		confirmation: false
	};
};
